import { render, staticRenderFns } from "./GiftBagSetting.vue?vue&type=template&id=197a74b2"
import script from "./GiftBagSetting.vue?vue&type=script&lang=js"
export * from "./GiftBagSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports